export default __webpack_public_path__ + "static/media/blog-padron.4c5174c9.jpg";